export default function LoadingIndicatorComponent() {
	'ngInject';
	return {
		restrict: 'E',
		scope: {
			loading: '<'
		},
		template: require('./loading-indicator.html')
	};
}
